import React from "react";
import TextBox from "../../../components/elements/form/TextBox";
// import { FaCommentAlt } from "react-icons/fa";
import { ICreateComment } from "../../../store/@types/blogs";
import Button from "../../../components/elements/form/Button";
import { useAppDispatch, useAppSelector } from "../../../store";
import { get_profile } from "../../../service/api/auth";
import { useNavigate, useParams } from "react-router-dom";
import { create_comments } from "../../../service/api/blog";

const CreateComment = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const profile = useAppSelector(({ auth }) => auth.user);
  const loading = useAppSelector(({ blog }) => blog.loading);

  const [data, dataSet] = React.useState<ICreateComment>({
    comment: "",
    blog_id: "",
  });

  const onLoad = React.useCallback(() => {
    if (id) {
      dataSet((prev) => ({ ...prev, blog_id: id }));
      get_profile(dispatch);
    }
  }, [dispatch, id]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <>
      {profile?.role ? (
        <>
          <h3 className="text-2xl font-bold mb-4">Leave a Comment</h3>
          <TextBox
            name="comment"
            type="text"
            label="Comment"
            placeholder="Enter Comment"
            status=""
            value={data.comment}
            className="h-[12.50rem]"
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
              dataSet((prev) => ({ ...prev, comment: e.target.value }))
            }
          />

          <div className="w-full my-2 mt-6">
            <div className="">
              <Button
                title="Post Comment"
                loading={loading}
                type="button"
                className="bg-primary-500 text-white text-[1rem] rounded-lg"
                onHandler={() => create_comments(dispatch, data)}
              />
            </div>
          </div>
        </>
      ) : (
        <h2 className="text-center text-[1.2rem] mb-4">
          <span
            onClick={() => navigate("/login")}
            className="cursor-pointer text-primary-500 hover:text-primary-700 transition-colors duration-300 mr-2"
          >
            Sign in
          </span>
          to leave a comment
        </h2>
      )}
    </>
  );
};

export default CreateComment;
